import React, { useEffect, useState, useMemo, useRef } from "react";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import { Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../../config/config";
import axios from "axios";
import JsBarcode from "jsbarcode";
import jsPDF from "jspdf";

const CustomerBarcodeLabel = () => {
  const [formValues, setFormValues] = useState([]);
  const barcodeRefs = useRef([]);
  const barcodeRequestParam = JSON.parse(localStorage.getItem("BarcodeRequestParam")).id ;
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const token = localStorage.getItem("Token");
  const settingids = localStorage.getItem("barcode-settings");
  const [selectedValue, setSelectedValue] = useState([]);

  const [placeHolder, setPlaceHolder] = useState("Load Selected Values");
  // const [selectDropdown, setSelectDropdown] = useState([]);
  const [id, setId] = useState(0);
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });
  console.log(barcodeRequestParam, "barcodeRequestParam");

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
    }), // dropdown input css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      position: "absolute",
      background: "#f8f8f8",
      width: "100%",
      zIndex: 99,
    }), // dropdown menu css
  };

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  // Function for generating the barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = `${index}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0"); // Zerofill at the barcode
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  const resetpage = () => {
    window.location.reload();
    localStorage.removeItem("barcode-settings");
  };

  // const value = options.map(data => {
  //   console.log(settingids);
  //   if (settingids?.includes(data.Barcode_Id)) {
  //     console.log(data.Barcode_Id);
  //     // const Drop = { value: data.Barcode_Id, label: data.SaveAs_Name };
  //     // console.log(Drop);
  //     setSelectedValue({ value: data.Barcode_Id, label: data.SaveAs_Name })
  //     // return Drop;

  //   }
  //   // else {
  //   // return null;
  //   // }
  // });
  // .filter(item => item !== null);

  // localStorage.removeItem("barcode-settings");

  //Function for downloading pdf
  const downloadPdf = () => {
    const pdf = new jsPDF();
    barcodeRefs.current.forEach((barcodeRef) => {
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");

      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
    });
    pdf.save("barcodes.pdf");
  };

  // useEffect for getting the selected data
  useEffect(() => {
    axios
      .get(`${config.customersBaseUrl}/customers/barcodeselectalltype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("hello", res.data.ResponseData);
        setOptions(res.data.ResponseData);
        setLoading(false);
        generateBarcodes();
        // handleLoadSettings();
        console.log(options);
        res.data.ResponseData.map((data) => {
          if (settingids?.includes(data?.Barcode_Id)) {
            console.log(data?.Barcode_Id);

            setSelectedValue({
              value: data?.Barcode_Id,
              label: data?.SaveAs_Name,
            });
            //handleUpdate({ value: data?.Barcode_Id, label: data?.SaveAs_Name });
          }
        });
      });

    axios
      .get(
        `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${barcodeRequestParam}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData);
        setFormValues(res.data.ResponseData);
        setTimeout(function () {
          generateBarcodes();
        }, 2000);
      });
  }, []);

  // Function for setting the value and updating the data
  const handleUpdate = (event) => {
    const selectedOption = options.find(
      (option) => option.value === event.value
    );
    setSelectedValue(event);
    console.log("he", event);
    axios
      .get(
        `${config.customersBaseUrl}/customers/barcodefindbyid?Barcode_Id=${event.value}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setId(res.data.ResponseData.CustomerBarcodeDetails[0]?.Barcode_Id);

        const data = {
          width:
            res.data.ResponseData.CustomerBarcodeDetails[0].BarcodeImageWidth,
          height:
            res.data.ResponseData.CustomerBarcodeDetails[0].BarcodeImageHeight,
          fontSize:
            res.data.ResponseData.CustomerBarcodeDetails[0]
              .BarcodeImageFontSize,
          zeroFill:
            res.data.ResponseData.CustomerBarcodeDetails[0].ZerofillBarcode,
          inputValue:
            res.data.ResponseData.CustomerBarcodeDetails[0].SaveAs_Name,
        };
        setData(data);
      })
      .catch((err) => {});
  };

  //Function for inserting the data
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      data.inputValue == null ||
      data.inputValue == undefined ||
      data.inputValue == ""
      // id == id
    ) {
      generateBarcodes();
    } else {
      try {
        const allDataToSend = {
          Barcode_Id: id,
          BarcodeImageWidth: data.width,
          BarcodeImageHeight: data.height,
          BarcodeImageFontSize: data.fontSize,
          ZerofillBarcode: data.zeroFill,
          SaveAs_Name: data.inputValue,
        };
        const response = await axios.post(
          `${config.customersBaseUrl}/customers/barcodeupsert`,
          allDataToSend,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        );
        generateBarcodes();
        localStorage.setItem(
          "barcode-settings",
          JSON.stringify(response.data.ResponseID)
        );
        console.log("res", response.data.ResponseData[0]);
        console.log("name", response.data.ResponseData[0].SaveAs_Name);
        console.log("ID", response.data.ResponseData[0].ID);
        const optionsList = {
          value: response.data.ResponseData[0].ID,
          label: response.data.ResponseData[0].SaveAs_Name,
        };
        setSelectedValue(optionsList);
        console.log("option", selectedValue);

        // window.location.reload();
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    }
  };

  console.log("selectedValue ==>", selectedValue);
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              {/* <div className="col"> */}
              <h3 className="page-title">Customers</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard" style={{ marginLeft: "12px" }}>
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/customers"> Customers List</Link>
                </li>
                <li className="breadcrumb-item active">
                  Customers Barcode Label
                </li>
              </ul>
              {/* </div> */}
            </div>
          </div>
          <br />
          <br />
          <div className="card">
            <div className="card-body">
              {/* input field */}

              <div className="col-md-4">
                <span>{selectedValue.value}</span>
                <span>{selectedValue.label}</span>
                <Select
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  isClearable={true}
                  onChange={(event) => handleUpdate(event)}
                  // options={dropdownselect}
                  options={options.map((data) => ({
                    value: data.Barcode_Id,
                    label: data.SaveAs_Name,
                  }))}
                  // value={options.find(
                  //   (obj) => obj.value == selectedValue.value
                  // )}
                  {...(selectedValue.value !== undefined ? (
                    <input value={selectedValue} />
                  ) : (
                    <input placeholder={placeHolder} />
                  ))}
                  styles={selectStyles}
                />
              </div>
              <br />

              <div className="row">
                <div className="mt-2 col-sm-4">
                  <label>Barcode Image Width: </label>
                  <input
                    name="width"
                    type="number"
                    value={data.width}
                    className="form-control "
                    onChange={handleChange}
                  />
                </div>
                <div className="mt-2 col-sm-4">
                  <label>Barcode Image Height: </label>
                  <input
                    name="height"
                    type="number"
                    value={data.height}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>

                <div className="mt-2 col-sm-4">
                  <label>Barcode Image FontSize: </label>
                  <input
                    name="fontSize"
                    type="number"
                    value={data.fontSize}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row">
                <div className="mt-2 col-sm-4">
                  <label>Barcode Zero Fill: </label>
                  <input
                    name="zeroFill"
                    type="number"
                    value={data.zeroFill}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
                <div className="mt-2 col-sm-4">
                  <label>Save Settings Above As:</label>
                  <input
                    name="inputValue"
                    type="text"
                    value={data.inputValue}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary me-1"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary me-1"
                    onClick={resetpage}
                  >
                    Reset
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={downloadPdf}
                  >
                    Download PDf
                  </button>
                </div>
              </div>
              <br />
              <br />
              {/* Generating the barcode with the help of Id */}
              {formValues.map((item) => (
                <div key={item.Id}>
                  <canvas
                    data-name={item.Id}
                    ref={(el) => (barcodeRefs.current[item.Id] = el)}
                    id={`barcode-${item.Id}`}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerBarcodeLabel;
